var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',_vm._g(_vm._b({staticClass:"mdc-text-field__icon",class:_vm.classes,on:{"_init":_vm.onParentInit}},'i',_vm.attrs,false),_vm.$listeners),[_vm._t("default",[_vm._v(_vm._s(_vm.icon))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }